import { useMemo } from 'react';
import { useAppContext } from 'src/contexts/AppContext';
import {
  getAllInPriceFromListPrice,
  getListPriceFromAllinPrice,
} from 'src/utils/inventoryUtils';
import { getMarketplaceSettings } from 'src/utils/userUtils';
import { Listing, Marketplace } from 'src/WebApiController';

export const useAllInPriceFromListPrice = (
  listPrice: number | null | undefined,
  listing?: Listing | null
) => {
  const { loginContext } = useAppContext();

  return useMemo(() => {
    const stubHubMkpSettings = getMarketplaceSettings(
      loginContext?.user?.activeAccount,
      Marketplace.StubHub,
      listing?.officeId
    );
    if (!listPrice) {
      return null;
    }
    return getAllInPriceFromListPrice(
      listPrice,
      listing,
      stubHubMkpSettings?.sellerFee
    );
  }, [listPrice, listing, loginContext?.user?.activeAccount]);
};

export const useListPriceFromAllInPrice = (
  allInPrice: number | null | undefined,
  listing?: Listing
) => {
  const { loginContext } = useAppContext();

  return useMemo(() => {
    const stubHubMkpSettings = getMarketplaceSettings(
      loginContext?.user?.activeAccount,
      Marketplace.StubHub,
      listing?.officeId
    );
    if (!allInPrice) {
      return null;
    }
    return getListPriceFromAllinPrice(
      allInPrice,
      listing,
      stubHubMkpSettings?.sellerFee
    );
  }, [allInPrice, listing, loginContext?.user?.activeAccount]);
};
